import React from "react";
import styled from "styled-components";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

const Page = styled.main`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background: #f4f5f7;
`;

const Panel = styled.section`
  width: 100%;
  max-width: 24rem;
  background: #ffffff;
  border: 1px solid #dfe1e6;
  border-radius: 6px;
  box-shadow: 0 8px 24px rgba(9, 30, 66, 0.12);
  padding: 1.5rem;
`;

const Title = styled.h1`
  font-size: 1.5rem;
  line-height: 1.3;
  font-weight: 700;
  color: #172b4d;
  margin: 0 0 0.5rem;
`;

const Description = styled.p`
  font-size: 0.875rem;
  line-height: 1.6;
  color: #5e6c84;
  margin: 0 0 1.25rem;
`;

const GoogleButton = styled.button`
  width: 100%;
  height: 2.75rem;
  border: 1px solid #dfe1e6;
  border-radius: 4px;
  background: #ffffff;
  color: #172b4d;
  font-size: 0.9375rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;

  &:hover {
    background: #f4f5f7;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }
`;

const GoogleMark = styled.span`
  color: #4285f4;
  font-weight: 700;
`;

const ErrorText = styled.p`
  color: #de350b;
  font-size: 0.8125rem;
  line-height: 1.5;
  margin: 1rem 0 0;
`;

export const LoginPage: React.FC = () => {
  const auth = useAuth();
  const location = useLocation();
  const from = (location.state as { from?: Location } | null)?.from;

  if (auth.state === "authenticated") {
    return <Navigate to={from?.pathname ?? "/workplaces"} replace />;
  }

  return (
    <Page>
      <Panel>
        <Title>Shiftas</Title>
        <Description>
          Googleアカウントを連携済みの方は、こちらから安全にログインできます。
        </Description>
        <GoogleButton
          type="button"
          onClick={auth.signInWithGoogle}
          disabled={auth.state === "initializing"}
        >
          <GoogleMark>G</GoogleMark>
          {auth.state === "initializing" ? "確認中..." : "Googleでログイン"}
        </GoogleButton>
        {auth.errorMessage && <ErrorText>{auth.errorMessage}</ErrorText>}
      </Panel>
    </Page>
  );
};
